export const analysisTr = {
  title: 'Analiz ve besin değeri profilleri',
  subtitle:
    'Kaynak izleme, kontrollü öncelik ve onay içeren sürümlü laboratuvar ve hesaplama değerleri.',
  help: { open: 'Analiz değerleri, hesaplama ve onay yardımını aç' },
  pagination: 'Sayfa {{page}} / {{pages}} · {{total}} sürüm',
  actions: {
    parameters: 'Analiz parametreleri',
    newParameter: 'Yeni parametre',
    newLaboratory: 'Laboratuvar profili gir',
    calculate: 'Reçeteyi hesapla',
    addValue: 'Değer ekle',
    submit: 'İncelemeye gönder',
    review: 'Teknik inceleme',
    approve: 'Onayla',
    copy: 'Yeni sürüm',
    archive: 'Arşivle',
    history: 'Sürüm geçmişi',
  },
  filters: {
    searchProfiles: 'Numara, ürün veya reçete ara',
    searchParameters: 'Anahtar veya ad ara',
    domain: 'Alan, ör. NUTRITION',
    allStatuses: 'Tüm durumlar',
    allOrigins: 'Tüm kaynak türleri',
  },
  statuses: {
    DRAFT: 'Taslak',
    IN_REVIEW: 'İncelemede',
    APPROVED: 'Onaylandı',
    SUPERSEDED: 'Değiştirildi',
    ARCHIVED: 'Arşivlendi',
  },
  origins: {
    ANALYZED: 'Analiz edildi',
    CALCULATED: 'Hesaplandı',
    MIXED: 'Laboratuvar değeri öncelikli',
  },
  targetTypes: { PRODUCT: 'Ürün', RECIPE: 'Reçete' },
  issueSeverity: { ERROR: 'Hata', WARNING: 'Uyarı' },
  aggregationModes: {
    MASS_BALANCE: 'Kütle dengesi / eklenebilir miktar',
    WEIGHTED_AVERAGE: 'Ağırlıklı ortalama',
    NOT_CALCULABLE: 'Otomatik hesaplanamaz',
  },
  roundingModes: { HALF_UP: 'Ticari yuvarlama', DOWN: 'Kes', UP: 'Sıfırdan uzağa' },
  columns: {
    number: 'Numara',
    target: 'Ürün / reçete',
    domain: 'Alan',
    origin: 'Kaynak',
    reference: 'Referans miktarı',
    version: 'Sürüm',
    status: 'Durum',
    issues: 'Hata / uyarı',
    key: 'Anahtar',
    name: 'Ad',
    parameter: 'Parametre',
    effective: 'Onay değeri',
    calculated: 'Hesaplanan',
    analyzed: 'Analiz edilen',
    range: 'Min / hedef / maks / tolerans',
    difference: 'Fark',
    hash: 'Anlık görüntü özeti',
    created: 'Oluşturuldu',
    validity: 'Geçerlilik',
  },
  fields: {
    key: 'Kalıcı anahtar',
    domain: 'Yapılandırılabilir alan',
    defaultUnit: 'Değer birimi',
    reference: 'Referans miktarı ve birimi',
    referenceQuantity: 'Referans miktarı',
    referenceUnit: 'Referans birimi',
    aggregation: 'Hesaplama yöntemi',
    retention: 'Tutma faktörü',
    rounding: 'Ondalık / yuvarlama',
    metadata: 'Yapılandırılabilir meta veriler (JSON)',
    changeReason: 'Değişiklik nedeni',
    validFrom: 'Geçerlilik başlangıcı',
    validTo: 'Geçerlilik bitişi',
    name: 'Ad',
    shortName: 'Kısa ad',
    description: 'Açıklama',
    reason: 'Gerekçe / inceleme notu',
    number: 'Profil numarası',
    numberFirst: 'Profil numarası (yalnız ilk sürüm)',
    targetType: 'Hedef türü',
    target: 'Hedef',
    source: 'Kaynak / laboratuvar / rapor',
    method: 'Ölçüm yöntemi',
    sampledAt: 'Numune / ölçüm zamanı',
    recipe: 'Onaylı reçete sürümü',
    laboratoryOverride: 'Kontrollü öncelikli onaylı laboratuvar sürümü',
    overrideReason: 'Laboratuvar önceliği gerekçesi',
    parameter: 'Analiz parametresi',
    value: 'Değer',
    unitCode: 'Birim',
    minValue: 'Minimum',
    maxValue: 'Maksimum',
    targetValue: 'Hedef',
    toleranceValue: 'Tolerans',
  },
  parameters: {
    title: 'Yapılandırılabilir analiz parametreleri',
    subtitle:
      'Sektörden bağımsız parametreler; besin değerleri yalnız yapılandırılabilir alanlarla tanımlanır.',
    createTitle: 'Analiz parametresi oluştur',
    editTitle: 'Analiz parametresi v{{version}} düzenle',
    editorHelp:
      'İnceleme öncesinde tüm diller zorunludur. Birim, tutma ve yuvarlama tekrarlanabilir sunucu hesaplarını yönetir.',
    historyTitle: 'Analiz parametresi sürüm geçmişi',
  },
  calculate: {
    title: 'Reçeteden analiz değerlerini hesapla',
    description:
      'Alt reçeteleri çözer; miktar, kayıp, verim, emilim, tutma ve yuvarlama kurallarını dikkate alır.',
    noOverride: 'Yalnız hesaplanan değerleri kullan',
    reviewWarning:
      'Sonuç incelenmesi gereken bir taslaktır. Eksik veya eski kaynaklar sessizce değiştirilmez.',
  },
  laboratory: {
    title: 'Analiz edilmiş profil gir',
    description:
      'Manuel değerlerin izlenebilir bir kaynağı olmalıdır. Raporlar daha sonra yalnız korumalı DMS kaydına yüklenir.',
    values: 'Ölçüm ve analiz değerleri',
    valueHelp: 'Minimum, maksimum, hedef ve tolerans isteğe bağlıdır; değer ve birim zorunludur.',
    dmsHelp:
      'Oluşturduktan sonra raporları profile yükleyin, taslakta seçin ve özetleriyle anlık görüntüleyin.',
    editTitle: 'Analiz edilmiş taslağı düzenle',
    editDescription:
      'Değerler ve DMS seçimi iyimser kilitleme kullanır. Gönderimden sonra içerik değiştirilemez.',
  },
  review: {
    title: 'Teknik inceleme gerekli',
    description:
      'Hesaplanan veya öncelikli laboratuvar değerleri otomatik teknik ya da yasal onay değildir. Kaynaklar, uyarılar ve sapmalar incelenmelidir.',
  },
  sections: {
    values: 'Onay, hesaplama ve laboratuvar değerleri',
    valuesHelp:
      'Onay değeri etkin anlık görüntü değeridir. MIXED için hesaplanan değer karşılaştırma amacıyla korunur.',
  },
  summary: {
    reference: 'Referans',
    values: 'Parametreler',
    errors: 'Hatalar',
    warnings: 'Uyarılar',
    validity: 'Geçerlilik',
  },
  tabs: {
    values: 'Değerler',
    sources: 'Kaynak izleme',
    validation: 'Doğrulama',
    comparison: 'Karşılaştırma',
    documents: 'Raporlar',
    history: 'Sürümler',
    snapshot: 'Anlık görüntü',
  },
  sources: {
    manual: 'Manuel girilen veya laboratuvarda analiz edilen değer',
    noCalculated: 'Bu değer için otomatik hesaplanan ham madde katkısı yok.',
  },
  comparison: {
    title: 'Sürümleri ve laboratuvar/hesaplama değerlerini karşılaştır',
    description: 'Değerler uyumlu birimlere dönüştürülür ve kesin ondalık farklar gösterilir.',
  },
  documents: {
    title: 'Korumalı laboratuvar ve test raporları',
    snapshotSelection: 'Bu taslak için belgeleri anlık görüntüle',
    snapshotHelp: 'Yalnız seçilen dosyalar ve SHA-256 özetleri bu profil sürümüne dahil olur.',
  },
  history: {
    title: 'Değiştirilemez sürüm geçmişi',
    description:
      'Onaylı sürümler sonraki kaynak değişikliklerine rağmen yeniden üretilebilir kalır.',
  },
  snapshot: { sources: 'Kaynak anlık görüntüsü', calculation: 'Hesaplama anlık görüntüsü' },
  states: {
    loading: 'Analiz değerleri yükleniyor…',
    noProfiles: 'Filtrelere uyan analiz profili sürümü yok.',
    noParameters: 'Filtrelere uyan analiz parametresi sürümü yok.',
    noIssues: 'Doğrulama hatası veya uyarı yok.',
    notFound: 'Analiz profili sürümü bulunamadı.',
  },
  messages: {
    saved: 'Analiz taslağı kaydedildi.',
    created: 'Laboratuvar profili oluşturuldu.',
    calculated: 'Tekrarlanabilir hesaplama taslağı oluşturuldu.',
    workflow: 'Analiz iş akışı güncellendi.',
  },
  workflow: {
    REVIEW: {
      title: 'Teknik incelemeyi belgele',
      description: 'İnceleyen kişi oluşturan ve gönderen kişiden bağımsız olmalıdır.',
    },
    APPROVE: {
      title: 'Analiz profilini onayla',
      description:
        'Onay; değerleri, kaynakları, kuralları, belge özetlerini ve uyarıları dondurur.',
    },
    COPY: {
      title: 'Analiz edilmiş sürümü kopyala',
      description: 'Tam kaynak izlemeli yeni, düzenlenebilir bir taslak oluşturur.',
    },
    ARCHIVE: {
      title: 'Analiz sürümünü arşivle',
      description: 'Denetlenebilir sürüm okunabilir kalır ve artık etkin kullanılmaz.',
    },
  },
} as const;
